<div class="page-wrapper">
  <div class="header">{{'repairIndex.description' | translate}}</div>
  <div class="content">
    <div>{{currentName$ | async}}</div>
    <div>({{currentIndex$ | async}} / {{dbTotal}})</div>
    <div class="loading-indicator"><itl-loading-indicator></itl-loading-indicator></div>
  </div>
</div>
